module.exports = __webpack_public_path__ + "static/img/handshakecolor.e69b981.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/handshakecolor.jpg
// module id = NxRh
// module chunks = 0